import { message } from "antd";
import { readUsers } from "@directus/sdk";
import { getDirectusClient } from "../../../lib/directus";
import * as XLSX from "xlsx";

const ExportClientsToExcel = async ({ setLoading, filters = {} }) => {
  try {
    setLoading(true);

    const directus = await getDirectusClient();

    // Obtener todos los clientes con los campos especificados
    const clients = await directus.request(
      readUsers({
        fields: [
          "first_name",
          "last_name",
          "email",
          "documento",
          "latitude",
          "longitude",
          "credito",
          "tope_credito",
          "dias_max_credito",
          "bodega.nombre",
          "tipo_cliente",
          "celular",
          "telefono",
          "representante_legal",
          "total_personas",
          "encargado",
          "codigo_establecimiento",
          "superior",
          "direccion",
        ],
        filter: {
          role: { name: { _contains: "clientes" } },
          ...filters, // Aplicar filtros adicionales si se proporcionan
        },
        sort: ["first_name"],
        limit: -1,
      })
    );

    // Preparar datos para Excel
    const excelData = clients.map((client) => ({
      Nombre: client.first_name || "",
      Apellido: client.last_name || "",
      Email: client.email || "",
      Documento: client.documento || "",
      Latitud: client.latitude || "",
      Longitud: client.longitude || "",
      Crédito: client.credito || 0,
      "Tope Crédito": client.tope_credito || 0,
      "Días Máx Crédito": client.dias_max_credito || 0,
      "Nombre Bodega": client.bodega?.nombre || "",
      "Tipo Cliente": client.tipo_cliente || "",
      Celular: client.celular || "",
      Teléfono: client.telefono || "",
      "Representante Legal": client.representante_legal || "",
      "Total Personas": client.total_personas || 0,
      Encargado: client.encargado || "",
      "Código Establecimiento": client.codigo_establecimiento || "",
      Superior: client.superior || "",
      Direccion: client.direccion || "",
    }));

    // Crear el libro de Excel
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(excelData);

    // Ajustar el ancho de las columnas
    const columnWidths = [
      { wch: 20 }, // Nombre
      { wch: 20 }, // Apellido
      { wch: 30 }, // Email
      { wch: 15 }, // Documento
      { wch: 15 }, // Rol
      { wch: 12 }, // Latitud
      { wch: 12 }, // Longitud
      { wch: 12 }, // Crédito
      { wch: 15 }, // Tope Crédito
      { wch: 18 }, // Días Máx Crédito
      { wch: 20 }, // Nombre Bodega
      { wch: 15 }, // Tipo Cliente
      { wch: 15 }, // Celular
      { wch: 15 }, // Teléfono
      { wch: 25 }, // Representante Legal
      { wch: 15 }, // Total Personas
      { wch: 20 }, // Encargado
      { wch: 25 }, // Código Establecimiento
      { wch: 15 }, // Superior
      { wch: 20 }, // Direccion
    ];

    worksheet["!cols"] = columnWidths;

    // Agregar la hoja al libro
    XLSX.utils.book_append_sheet(workbook, worksheet, "Clientes");

    // Generar el archivo Excel
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    // Crear el blob y descargar
    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `clientes_${new Date().toISOString().split("T")[0]}.xlsx`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    message.success(`Se exportaron ${clients.length} clientes exitosamente`);
  } catch (error) {
    console.error("Error al exportar clientes a Excel:", error);
    message.error("Error al exportar clientes a Excel");
  } finally {
    setLoading(false);
  }
};

export default ExportClientsToExcel;
